'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { PopularLinks } from './popular-links';
import RecommendedJobs from './jobs/recommended-jobs';
import { SalaryChart } from './salary-chart';
import { SalaryLink } from './salary-link';
import { SalaryChartType } from '~/services/job-search/fetch-salary-chart';
import { JobDetail } from '~/types/job-detail';
import type { PopularLinks as PopularLinksType } from '~/services/job-search/fetch-jobs';
import { ConditionParam } from '~/types/condition-param';
import { isMobile } from 'react-device-detect';

interface SidebarProps {
  popularLinks: PopularLinksType;
  currentApplicant: any;
  recommendedJobs: {
    recommended_jobs: JobDetail[];
    other_watched_jobs_present: boolean;
  };
  conditionText: string;
  salaryChart: SalaryChartType;
  conditionParams: ConditionParam[];
}

const Sidebar: React.FC<SidebarProps> = ({
  popularLinks,
  currentApplicant,
  recommendedJobs,
  conditionText,
  salaryChart,
  conditionParams,
}) => {
  const [isClientMobile, setIsClientMobile] = useState(false);

  useEffect(() => {
    setIsClientMobile(isMobile);
  }, []);

  return (
    <div className="l-sidebar flex flex-col">
      {!isClientMobile && (
        <>
          <div className="hidden md:block">
            <PopularLinks popularLinks={popularLinks} />
          </div>

          {!!currentApplicant ? (
            <RecommendedJobs
              jobs={recommendedJobs.recommended_jobs}
              otherWatchedJobsPresent={
                recommendedJobs.other_watched_jobs_present
              }
            />
          ) : (
            <>
              <div className="u-mt20">
                <Link href="/entry_member?ref=jobs-sidebar-banner1-scout">
                  <Image
                    src="/nextjs/images/banner/banner_scouts.webp"
                    alt="登録してスカウト機能を使う"
                    width={320}
                    height={320}
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 768px) 100vw, 320px"
                  />
                </Link>
              </div>

              <div className="u-mt20">
                <Link href="/entry_member?ref=jobs-sidebar-banner2">
                  <Image
                    src="/nextjs/images/banners/jobs_banar2.webp"
                    alt="建職バンクのご利用が初めての方へ"
                    width={320}
                    height={653}
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 768px) 100vw, 320px"
                  />
                </Link>
              </div>

              <div className="u-mt20">
                <Link href="/entry_member?ref=jobs-sidebar-banner3">
                  <Image
                    src="/nextjs/images/banners/jobs_banar3.webp"
                    alt="無料登録、プロにお仕事探しの相談をしてみる"
                    width={320}
                    height={393}
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 768px) 100vw, 320px"
                  />
                </Link>
              </div>
            </>
          )}
        </>
      )}
      <SalaryChart
        conditionText={conditionText}
        bins={salaryChart.bins}
        freqs_ratio={salaryChart.freqs_ratio}
        salary_ave_total={salaryChart.salary_ave_total}
        jobs_total={salaryChart.jobs_total}
      />
      <SalaryLink conditionParam={conditionParams} />
      {!isClientMobile && (
        <div className="c-qr u-mt28">
          <div className="c-qr__overlap">スマホで新着求人をチェック！</div>
          <Image
            src="/nextjs/images/banner/qr_for_list.png"
            alt="スマホサイトQRコード"
            loading="lazy"
            className="c-qr__QR"
            width={320}
            height={320}
            sizes="320px"
          />
          <div className="c-qr__text-wrapper">
            新着求人をいつでもチェックできます
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
